import { FooterComponent } from './modules/mapfre-design-library/src/lib/_components/global-components/footer/footer.component';
import { HeaderComponent } from './modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { MapfreButtonComponent } from './modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from './modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from './modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Router, NavigationEnd , RouterModule  } from '@angular/router';
import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'underscore';
import { Language, ModalOptions } from '@mapfre-design-library/src/public_api';
import { environment } from '@env/environment';
import { ErrorServiceService } from './_services/error-service/error-service.service';
// import { SwUpdate } from '@angular/service-worker';
// import * as packageInfo from '@env/PROD/package.json';
import { FeatureToggleService } from './_services/misc-services/feature-toggle.service';
import { ClientCredentialsService } from './_services/client-credentials/client-credentials.service';
import { ClientCredentialsTokenService } from './_services/client-credentials/client-credentials-token.service';
import { Location, DOCUMENT , CommonModule } from '@angular/common';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { DigitalDataService } from './_services/data-services/digital-data.service';
import { filter } from 'rxjs/operators';
import { SplashScreen } from '@capacitor/splash-screen';
import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { LogoutService } from './_services/_iam/logout.service';
import { PwaService } from './_services/pwa-service/pwa.service';
import { BiometricAuthService } from './_services/biometric-auth/biometric-auth.service';
import { DtHelperService } from '@services/dt-helper.service';
import { AdobeHelperService } from '@services/adobe-helper.service';
import { OktaAuthService } from '@services/_iam/okta-auth.service';
import { OneIncHelperService } from '@services/one-inc-helper.service';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent, HeaderComponent, FooterComponent],
  selector: 'mapfre-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  title = 'Mapfre Insurance';
  checkThisRoute = false;
  appVersion = "15.0.6";
  isAvailable = false;
  stateCode = 'MA';
  currentRoute: string;
  buttonClass: string;
  isNativeApp: boolean;
  isUpdateNeeded: boolean;
  appUpdateModal: ModalOptions;
  hideModalOnRoute: boolean;
  appLink: string;
  forceUpdate: boolean;
  connectivity: boolean;
  showConnectivity: boolean;
  iosURL: string;
  androidURL: string;

  constructor(
    public _languages: Language,
    private errorServices: ErrorServiceService,
    private router: Router,
    private location: Location,
    @Inject(DOCUMENT) private document: Document,
    public translate: TranslateService,
    // private swUpdate: SwUpdate,
    private featureToggleService: FeatureToggleService,
    private clientCredentialsService: ClientCredentialsService,
    private clientCredentialsTokenService: ClientCredentialsTokenService,
    private acmicService: AcmicService,
    private digitalDataService: DigitalDataService,
    private zone: NgZone,
    private logoutService: LogoutService,
    private pwaService: PwaService,
    private bioMetricAuth: BiometricAuthService,
    private dtHelperService: DtHelperService,
    private adobeHelperService: AdobeHelperService,
    private oneIncHelperService: OneIncHelperService,
    private oktaAuthService: OktaAuthService

  ) {
   // Do NOT call initialize()/handleLoginRedirect() on the callback route.
    // OktaCallbackComponent (registered at /login/callback) exclusively owns
    // handleLoginRedirect() there via the APP_INITIALIZER in app.initializer.ts.
    // AppComponent is the root component and is always constructed, including
    // when navigating to /login/callback — calling initialize() here too would
    // race with OktaCallbackComponent.ngOnInit() to consume the single-use
    // PKCE code/codeVerifier concurrently, causing:
    // "AuthSdkError: Could not load PKCE codeVerifier from storage."
    const isCallbackRoute = window.location.pathname.includes('/login/callback');
    if (!isCallbackRoute && !this.isAuthenticated()) {
      this.oktaAuthService.initialize();       //handles refresh or revisit
    }
    this.checkRoute();
    this.detectStateCode();
    this.addBGWhite();
    this.onAppLoad();
    this.dtHelperService.addDynatraceScript();
    this.adobeHelperService.injectScript();
    this.oneIncHelperService.injectScript();
  }
  async isAuthenticated() {
    return await this.oktaAuthService.isAuthenticated();
  }
  isSSR() {
    return window.location;
  }
  addBGWhite() {
    if (this.router.isActive('/login', true)) {
      return 'white-background';
    }
  }
  onRouteChange() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (event['url']) {
          this.currentRoute = event['url'];
          this.digitalDataService.updateDigitalData(event['url']);
          this.triggerStepView(this.currentRoute);
          // Re-detect state code on every navigation — ensures ACMIC CSS is applied
          // correctly after the Okta /login/callback redirect (where stateCode param
          // is gone but sessionStorage flag is now set).
          this.detectStateCode();
        }
      });
  }

  triggerStepView(routeName) {
    const path = routeName.split('/').pop() || 'login';
    const stepViewFunExp = window['stepView'];
    if (stepViewFunExp) {
      stepViewFunExp(path);
    }
  }
  onAppLoad() {
    if (this.isSSR()) {
      App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
        this.zone.run(() => {
          const domain = 'mapfreinsurance.com';

          const pathArray = event.url.split(domain);

          const appPath = pathArray.pop();
          if (appPath) {
            this.router.navigateByUrl(appPath);
          }
        });
      });
    }
  }
  checkRoute() {
    /* ** ToDo: Create a better loop ** */
    const rs = [
      '/my-insurance',
      '/billing',
      '/claims',
      '/information',
      '/contact',
      '/profile',
      '/policy',
      '/policy',
      '/contact',
      '/faq',
      '/id-cards',
      '/billing-new',
      '/home'
    ];
    if (
      this.router.isActive(rs[0], false) ||
      this.router.isActive(rs[1], false) ||
      this.router.isActive(rs[2], true) ||
      this.router.isActive(rs[3], true) ||
      this.router.isActive(rs[4], true) ||
      this.router.isActive(rs[5], false) ||
      this.router.isActive(rs[6], true) ||
      this.router.isActive(rs[7], true) ||
      this.router.isActive(rs[8], true) ||
      this.router.isActive(rs[9], false) ||
      this.router.isActive(rs[10], true) ||
      this.router.isActive(rs[11], false) ||
      this.router.isActive(rs[12], false)
    ) {
      return 'loggedin-footer';
    } else {
      return 'footer';
    }
  }

  findLanguage(): void {

    // Created variable for get default language stored in localstorage
    const localStorageLang = localStorage.getItem('defaultUserLanguage');
    // set conditionally localstorage language when it found else set navigator language
    const lang = localStorageLang ? localStorageLang : navigator.language;
    const fianllang =
      lang.indexOf('-') !== -1
        ? lang.slice(0, lang.indexOf('-')).toUpperCase()
        : lang.toUpperCase();
    if (this.stateCode) {
      _.each(this._languages['lang'][this.stateCode], (val) => {
        this.translate.setTranslation(val['identifier'], val['sentences']);
      });
    }

    this.translate.setDefaultLang(fianllang);
    this.setLang(fianllang);
  }

  setLang(lang: string): void {
    this.translate.use(lang);
  }

  appendStateCSS(state) {
    const stateClass =
      state.toLocaleLowerCase() === 'acmic' ? 'acmic' : 'non-acmic-insurence';
    const body = this.document.getElementsByTagName('body')[0];
    body.setAttribute('class', stateClass);
    if (state === 'MA') {
      return;
    }

    const currTimeInMills = new Date().getTime();
    const head = document.getElementsByTagName('head')[0];
    const style: HTMLLinkElement = document.createElement('link');
    style.id = 'css-styling';
    style.rel = 'stylesheet';
    style.type = 'text/css';
    style.href = `/assets/scss/style_${state}.css?v=${currTimeInMills}`;
    head.appendChild(style);
  }
  isAcmic() {
    return !this.document.location.origin.includes('acmic');
  }
  detectStateCode() {
    if (this.acmicService.isACMIC()) {
      this.stateCode = 'ACMIC';
      this.buttonClass = 'basic default maintenance acmic';
    } else {
      this.buttonClass = 'basic default maintenance';
    }
    this.appendStateCSS(this.stateCode);
  }
  isACMIC() {
    console.log(this.acmicService.isACMIC());
  }

  ngOnInit() {
    this.findLanguage();
    this.onBackClick();
    if (!this.currentRoute) {
      const path = this.location.path();
      this.digitalDataService.setVersion(this.appVersion);
      this.digitalDataService.updateDigitalData(path);
    }
    this.onRouteChange();
    this.errorServices.noConsolesInProd(environment.production);
    if (Capacitor.isNativePlatform()) {
      this.checkInternetConnection();
      this.checkAppAvailability();
    } else {
      if (!this.clientCredentialsTokenService.getToken()) {
        this.checkAppAvailability();
      }
    }
    this.isACMIC();
    // this.isSWUpdate();
    this.performBiometricsAuth();
  }

  getAppLinks() {
    this.pwaService.setIosAndroidURL("https://apps.apple.com/us/app/go-mapfre/id1589952585,https://play.google.com/store/apps/details?id=com.mapfreinsurance.myaccount", true);
    this.pwaService.$appLinks.subscribe((data) => {
      this.iosURL = data.iosURL;
      this.androidURL = data.androidURL;
    });
  }

  checkInternetConnection() {
    this.getNetworkStatus();
    Network.addListener('networkStatusChange', (status) => {
      this.connectivity = status.connected;
      this.showConnectivity = true;
      if (status.connected) {
        setTimeout(() => {
          this.showConnectivity = false;
        }, 100);
      }
    });
  }

  getNetworkStatus() {
    Network.getStatus().then((status) => {
      this.connectivity = status.connected;
      if (this.connectivity) {
        this.showConnectivity = false;
      } else {
        this.showConnectivity = true;
      }
    });
  }

  splashScreenHide() {
    SplashScreen.show({
      showDuration: 20000,
      autoHide: true,
    });
  }

  goBack() {
    this.location.back();
  }

  checkAppAvailability() {
    this.clientCredentialsService.getToken().subscribe(() => {
      this.checkForAvailableUpdates();
      this.getAppLinks();
      this.featureToggleService.isAvailable(1).subscribe((response) => {
        if (!("isAvailable" in response)) {
          this.isAvailable = true;
        } else if (response.isAvailable) {
          this.isAvailable = response.isAvailable;
        }
      }, () => {
        // Intentionally ignore errors from this check.
      });
    });
  }

  // isSWUpdate() {
  //   if (this.swUpdate.isEnabled) {
  //     this.swUpdate.available.subscribe((event) => {
  //       window.location.reload();
  //     });
  //   }
  // }

  checkForAvailableUpdates() {
    if (Capacitor.isNativePlatform()) {
      this.isNativeApp = true;
      if (Capacitor.getPlatform() == 'ios') {
        this.appLink = this.iosURL;
      } else {
        this.appLink = this.androidURL;
      }
      this.featureToggleService.isAvailable('6').subscribe((response) => {
        App.getInfo().then((result) => {
          if (response.isAvailable && response.url > result.version) {
            this.forceUpdate = true;
            this.isUpdateNeeded = true;
            this.modalAppLoad();
          } else if (response.url > result.version) {
            this.isUpdateNeeded = true;
            this.modalAppLoad();
          }
        });
      });
    }
  }

  onBackClick() {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() == 'android') {
      App.addListener('backButton', ({ canGoBack }) => {
        this.zone.run(() => {
          if (!canGoBack) {
            this.onExitApp();
          }
          if (this.checkRoute() == 'loggedin-footer') {
            const x = confirm(
              'You will be logged out of the application. Do you want to continue?'
            );
            if (x) {
              this.logoutService.logout();
              this.onExitApp();
            }
          } else {
            this.onExitApp();
          }
        });
      });
    }
  }

  performBiometricsAuth() {
    if (
      Capacitor.isNativePlatform() &&
      this.bioMetricAuth.isBiometricStored()
    ) {
      if (this.router.url == '/' && localStorage.getItem('currentUser')) {
        this.bioMetricAuth
          .performBiometricVerification()
          .then((resp) => {
            if (!resp) {
              this.onExitApp();
            }
          })
          .catch(() => false);
      }
    }
  }
  onExitApp() {
    App.exitApp();
  }

  modalAppLoad() {
    this.appUpdateModal = new ModalOptions({
      additionalClasses:
        'modal-small modal-dialog center-on-page confirm-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'appUpdateModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalTranslateCopy: 'Update Available',
      typeOfModal: 'accountConfirm',
      screenReader: true,
      showIcons: true,
      modalName: 'profile_Confirm',
    });
  }

  hideModal(u?) {
    this.hideModalOnRoute = !this.hideModalOnRoute;
    if (this.forceUpdate && u != 'update') {
      this.onExitApp();
    }
  }

}
